import { render, staticRenderFns } from "./RefsCompany.vue?vue&type=template&id=2eeb5ec0&scoped=true"
import script from "./RefsCompany.vue?vue&type=script&lang=ts"
export * from "./RefsCompany.vue?vue&type=script&lang=ts"
import style0 from "./RefsCompany.vue?vue&type=style&index=0&id=2eeb5ec0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeb5ec0",
  null
  
)

export default component.exports